import React, { useContext, useState } from "react";
import { Image, StyleSheet, Text, View } from "react-native";
import { SafeAreaView } from "react-navigation";
import BetterAlert from "../../components/BetterAlert";
import Button from "../../components/Button";
import ButtonBack from "../../components/ButtonBack";
import CaixaTextoInputIcone from "../../components/TextBoxIcon";
import { AuthContext } from "../../contexts/auth";
import { ChangePasswordByUser } from "../../services/Api/login";
import { Encrypt } from "../../services/Crypt";
import * as Colors from "../../styles/colors";
import * as Fonts from "../../styles/typography";

export default function ChangePassword({ route, navigation }) {
  const { tokenApi, getNewTokenApi } = useContext(AuthContext);
  const idUser = route.params.idUser;
  const [password, setPassword] = useState("");
  const [passwordConfirmation, setPasswordConfirmation] = useState("");
  const [showAlert, setShowAlert] = useState({});

  const changePasswordApi = (newPassword, idUser) => {
    let token = tokenApi;
    if (!token) {
      token = getNewTokenApi().then((tokenJson) => token = tokenJson);
    }

    ChangePasswordByUser(Encrypt(newPassword), idUser, tokenApi)
      .then((response) => {
        if (response.statusCode) {
          setShowAlert({
            type: "success",
            title: "Atenção",
            message: "Senha alterada com sucesso",
            show: true,
            confirmText: "OK",
            pressConfirm: () => {
              setShowAlert({ ...showAlert, show: false });
              navigation.navigate("Login");
            },
          });
        } else {
          let msgErro = response.reason;
          setShowAlert({
            type: "warning",
            title: "Atenção",
            message: msgErro,
            show: true,
            confirmText: "OK",
            pressConfirm: () => {
              setShowAlert({ ...showAlert, show: false });
            },
          });
        }
      })
      .catch((error) => {
        setShowAlert({
          type: "warning",
          title: "Atenção",
          message: "Não foi possível realizar o reset de senha",
          show: true,
          confirmText: "OK",
          pressConfirm: () => {
            setShowAlert({ ...showAlert, show: false });
          },
        });
      });
  };

  return (
    <SafeAreaView style={styles.container}>
      <ButtonBack navigation={navigation} />
      <Image
        source={require("../..//../assets/images/logo-trevo-login.png")}
        style={styles.logoPequeno}
      />
      <Text style={styles.inputLogin}>Por favor, digite a sua nova senha</Text>

      <CaixaTextoInputIcone
        iconName={"key"}
        placeholderInput={"Senha"}
        onChangeTextInput={(password) => setPassword(password)}
        isSenha={true}
        value={password}
        textContentType={"password"}
      />

      <CaixaTextoInputIcone
        iconName={"key"}
        placeholderInput={"Confirme sua senha"}
        onChangeTextInput={(password) => setPasswordConfirmation(password)}
        isSenha={true}
        value={passwordConfirmation}
        textContentType={"password"}
      />

      <Button
        textoBotao={"Confirmar"}
        estilo={styles.button}
        onPress={() => {
          if (password.length < 5) {
            setShowAlert({
              type: "warning",
              title: "Atenção",
              message:
                "A senha está muito curta, poderia tentar colocar uma senha mais forte?",
              show: true,
              confirmText: "OK",
              pressConfirm: () => {
                setShowAlert({ ...showAlert, show: false });
              },
            });
          } else if (password != passwordConfirmation) {
            setShowAlert({
              type: "warning",
              title: "Atenção",
              message: "As senhas não coincidem",
              show: true,
              confirmText: "OK",
              pressConfirm: () => {
                setShowAlert({ ...showAlert, show: false });
              },
            });
          } else {
            changePasswordApi(password, idUser);
          }
        }}
      />

      <View style={{ justifyContent: "flex-end" }}>
        <View
          style={{
            flexDirection: "row",
            alignItems: "center",
            marginTop: 10,
            marginBottom: 10,
          }}
        >
          <View style={{ flex: 1, height: 1, backgroundColor: "black" }} />
          <View>
            <Text style={{ width: 50, textAlign: "center" }}>Ou</Text>
          </View>
          <View style={{ flex: 1, height: 1, backgroundColor: "black" }} />
        </View>
        <Text
          style={{
            fontSize: Fonts.FONT_SIZE_16,
            textAlign: "center",
            marginTop: 15,
          }}
        >
          Lembrou a senha?{" "}
        </Text>
        <Text
          onPress={() => navigation.navigate("Login")}
          style={{
            fontSize: Fonts.FONT_SIZE_22,
            textAlign: "center",
            marginTop: 1,
            fontWeight: "bold",
          }}
        >
          Faça Login
        </Text>
      </View>
      <BetterAlert {...showAlert} />
    </SafeAreaView>
  );
}

const styles = StyleSheet.create({
  logoPequeno: {
    marginBottom: 10,
    resizeMode: "stretch",
    width: 240,
    height: 74,
  },
  inputLogin: {
    fontSize: Fonts.FONT_SIZE_25,
    textAlign: "center",
    marginBottom: 20,
    // fontWeight: 'bold',
    color: Colors.WELCOME_TEXT,
  },
  container: {
    flex: 1,
    flexGrow: 1,
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: Colors.WHITE,
  },
  button: {
    width: "70%",
  },
  instructions: {
    fontSize: Fonts.FONT_SIZE_14,
    textAlign: "center",
    padding: 16,
    marginTop: -24,
  },
});
